import style from "./FeaturesBlock.module.scss";
import Image from "next/image";

function FeaturesBlock({ dictionary }) {
	const IMAGES_ARR = [
		{
			name: dictionary["move_scale"] || "Move & scale objects.",
			src_adaptive: "/remove_back/features_block/feature1_adaptive.png",
			src: "/remove_back/features_block/feature_one.png",
		},
		{
			name: dictionary["add_music_text_stickers_removebg"] || "Add music, stickers, and text.",
			src_adaptive: "/remove_back/features_block/feature2_adaptive.png",
			src: "/remove_back/features_block/feature_two.png",
		},
		{
			name: dictionary["apply_filters"] || "Apply various filters.",
			src_adaptive: "/remove_back/features_block/feature3_adaptive.png",
			src: "/remove_back/features_block/feature_three.png",
		},
	];

	const title = dictionary["page_removebg_header_editing"] || "Make your video stunning with easy video editing";

	return (
		<section className={style.section}>
			<h2 className={style.title}>{title}</h2>
			<div className={style.container}>
				{IMAGES_ARR.map((image) => (
					<div key={image.name} className={style.media} data-title={image.name}>
						<Image className={style.image} src={image.src} alt={image.name} width="501" height="421" loading="lazy" />
						<Image className={style.adaptiveImage} src={image.src_adaptive} alt={image.name} width="300" height="255" loading="lazy" />
					</div>
				))}
			</div>
		</section>
	);
}

export default FeaturesBlock;
